export var SEND_STRIPE_TOKEN = 'SEND_STRIPE_TOKEN';
export var SEND_STRIPE_TOKEN_SUCCESS = 'SEND_STRIPE_TOKEN_SUCCESS';
export var SEND_STRIPE_TOKEN_FAILURE = 'SEND_STRIPE_TOKEN_FAILURE';
export var PREMIUM_CODE_ENTERED = 'PREMIUM_CODE_ENTERED';
var STATE_DEFAULT = {
  sendingStripeToken: false,
  stripeChargeComplete: false,
  stripeChargeErrorMsg: '',
  codesToAmountsInCents: {
    CODE1098234AFX: 100000,
    CODE1098234AEX: 200000,
    CODE1098234ACX: 500000,
    CODE1098234ADX: 700000
  },
  userCode: 0,
  userAmountInCents: 0,
  productOptions: [{
    value: 'individual',
    title: 'Individual COSMOS'
  }, {
    value: 'institutional',
    title: 'Institutional COSMOS'
  }, {
    value: 'mikrocosmos',
    title: 'mikroCOSMOS'
  }, {
    value: 'tailored',
    title: 'Tailored COSMOS'
  }]
};
export default function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATE_DEFAULT;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SEND_STRIPE_TOKEN:
      return Object.assign({}, state, {
        sendingStripeToken: true,
        stripeChargeComplete: false,
        stripeChargeErrorMsg: ''
      });

    case SEND_STRIPE_TOKEN_SUCCESS:
      return Object.assign({}, state, {
        sendingStripeToken: false,
        stripeChargeComplete: true,
        stripeChargeErrorMsg: ''
      });

    case SEND_STRIPE_TOKEN_FAILURE:
      return Object.assign({}, state, {
        sendingStripeToken: false,
        stripeChargeComplete: false,
        stripeChargeErrorMsg: action.msg
      });

    case PREMIUM_CODE_ENTERED:
      return Object.assign({}, state, {
        userCode: action.userCode,
        userAmountInCents: state.codesToAmountsInCents[action.userCode]
      });

    default:
      return state;
  }
}